import styled, { css } from 'styled-components'
import { ButtonColor, ElementSizeType, shadowMaterialList } from '@styles/theme-const'
import { ThemeColors } from 'src/shared/ui/consts-styles'
import { ElementSize } from 'src/shared/ui/styles/type' // noinspection DuplicatedCode

// noinspection DuplicatedCode
interface ButtonElementProps {
    isShadow: boolean
    isClickable?: boolean
    textTransform?: string
    isDisabled: boolean | undefined
    elementSizeTypeValue: ElementSize
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    children: any
    colors?: ButtonColor
}

export const ButtonElement = styled.button<ButtonElementProps>`
    border: 0;
    background-color: ${(props) => props.colors?.backgroundColor};
    color: ${(props) => props.colors?.color || 'inherit'};
    border-radius: 0.3rem;
    font-size: inherit;
    box-sizing: border-box;
    user-select: none;
    ${(props) =>
        props.isShadow && !props.colors?.borderColor && props.colors?.shadowColor
            ? css`
                  box-shadow: ${shadowMaterialList.getShadowKitColor(props.colors?.shadowColor)};
              `
            : ''}
    ${(props) => {
        if (props.isClickable) {
            return css`
                cursor: pointer;
            `
        }
        return css`
            cursor: default;
        `
    }};
    ${(props) =>
        props.colors?.borderColor &&
        css`
            border: 1px solid ${props.colors?.borderColor};
        `};

    ${(props) =>
        props.isClickable &&
        css`
            &:hover:enabled {
                ${props.isShadow &&
                props.colors?.shadowHoverColor &&
                `box-shadow: ${shadowMaterialList.getShadowKitColor(props.colors?.shadowHoverColor)}`}
                ${!props.isShadow && `background-color: ${props.colors?.hoverBackgroundColor}`}
            }
        `}

    ${(props) => {
        if (props.elementSizeTypeValue === ElementSizeType.large) {
            return css`
                font-size: 1.2rem;
                padding: 0.9rem 1.6rem;
            `
        }
        if (props.elementSizeTypeValue === ElementSizeType.regular) {
            return css`
                padding: 0.7rem 1.2rem;
                text-transform: ${(props) =>
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    props.textTransform};
            `
        }
        if (props.elementSizeTypeValue === ElementSizeType.small) {
            return css`
                font-size: 0.8rem;
                padding: 0.7rem 1.2rem;
            `
        }
        if (props.elementSizeTypeValue === ElementSizeType.superSmall) {
            return css`
                font-size: 0.8rem;
            `
        }
    }};

    ${(props) =>
        props.isDisabled &&
        css`
            box-shadow: none;
            opacity: 0.6;

            /*   &:hover {
                background-color: ${ThemeColors.getGrayColor(0.1)};
            }*/

            // cursor: default;
        `}

    ${(props) =>
        !props.isClickable &&
        css`
            box-shadow: none;
            opacity: 0.6;
            cursor: default;
            background-color: ${ThemeColors.getGrayColor(0.1)};
        `}
`

export const ButtonLinkElement = styled.a<ButtonElementProps>`
    border: 0;
    background-color: ${(props) => props.colors?.backgroundColor};
    color: ${(props) => props.colors?.color};
    border-radius: 0.3rem;
    font-size: inherit;
    box-sizing: border-box;
    text-align: center;
    ${(props) =>
        props.isShadow && !props.colors?.borderColor && props.colors?.shadowColor
            ? css`
                  box-shadow: ${shadowMaterialList.getShadowKitColor(props.colors?.shadowColor)};
              `
            : ''}
    ${(props) => {
        if (props.isClickable) {
            return css`
                cursor: pointer;
            `
        }
        return css`
            cursor: default;
        `
    }};
    ${(props) =>
        props.colors?.borderColor &&
        css`
            border: 1px solid ${props.colors?.borderColor};
        `};

    ${(props) => {
        if (props.isClickable)
            return css`
                &:hover:enabled {
                    ${
                        props.isShadow &&
                        props.colors?.shadowHoverColor &&
                        `box-shadow: ${shadowMaterialList.getShadowKitColor(props.colors?.shadowHoverColor)}`
                    }
                    ${!props.isShadow && `background-color: ${props.colors?.hoverBackgroundColor}`}
            `
    }}

    ${(props) => {
        if (props.elementSizeTypeValue === ElementSizeType.large) {
            return css`
                font-size: 1.2rem;
                padding: 0.9rem 1.6rem;
            `
        }
        if (props.elementSizeTypeValue === ElementSizeType.regular) {
            return css`
                padding: 0.7rem 1.2rem;
                text-transform: ${(props) =>
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    props.textTransform};
            `
        }
        if (props.elementSizeTypeValue === ElementSizeType.small) {
            return css`
                font-size: 0.8rem;
                padding: 0.7rem 1.2rem;
            `
        }
        if (props.elementSizeTypeValue === ElementSizeType.superSmall) {
            return css`
                font-size: 0.8rem;
            `
        }
    }};

    ${(props) =>
        props.isDisabled &&
        css`
            box-shadow: none;
            opacity: 0.6;

            /*   &:hover {
                background-color: ${ThemeColors.getGrayColor(0.1)};
            }*/

            // cursor: default;
        `}

    ${(props) =>
        !props.isClickable &&
        css`
            box-shadow: none;
            opacity: 0.6;
            cursor: default;
            background-color: ${ThemeColors.getGrayColor(0.1)};
        `}
`
